module.exports = __webpack_public_path__ + "static/media/Stitch-Shop_88.f5b3c5b7.webp";